import apiService from '../../../services/api-client';
import { GetClassResponse } from '../interfaces/get-class';
import { GetClassesParams, GetClassesResponse } from '../interfaces/get-classes';
import { PostClassPayloadRequest, PostClassResponse } from '../interfaces/post-class';
import { PostClassSeenResponse } from '../interfaces/post-class-seen';
import { PutClassPayloadRequest } from '../interfaces/put-class';

export const classApiService = {
  async getClasses(params: GetClassesParams) {
    const { data } = await apiService().get<GetClassesResponse>(
      `classes`,
      {
        params: { ...params },
      }
    );
    return data;
  },
  async getClass(id: string) {
    const { data } = await apiService().get<GetClassResponse>(
      `classes/${id}`
    );
    return data;
  },
  async postClass(body: PostClassPayloadRequest) {
    const formData = new FormData();

    formData.append('name', body.name);
    formData.append('description', body.description);
    formData.append('secuentialEmail', body.secuentialEmail);
    formData.append('permanent', String(body.permanent));
    formData.append('moduleId', body.moduleId);
    formData.append('visibility', body.visibility);
    formData.append('categories', body.categories.join(','));

    formData.append('videos', JSON.stringify(body.videos));
    formData.append('links', JSON.stringify(body.links));
    formData.append('sendEmail', String(body.sendEmail));
    
    body.newFiles.forEach((file) => {
      formData.append('files', file);
    });

    const { data } = await apiService().post<PostClassResponse>(
      `classes`,
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return data;
  },
  async putClass(id: string, body: PutClassPayloadRequest) {
    const formData = new FormData();

    formData.append('name', body.name);
    formData.append('description', body.description);
    formData.append('secuentialEmail', body.secuentialEmail);
    formData.append('permanent', String(body.permanent));
    formData.append('moduleId', body.moduleId);
    formData.append('visibility', body.visibility);
    formData.append('categories', body.categories.join(','));
  
    formData.append('videos', JSON.stringify(body.videos));
  
    formData.append('links', JSON.stringify(body.links));
    
    formData.append('oldFiles', JSON.stringify(body.files));

    body.newFiles.forEach((file) => {
      formData.append('files', file);
    });

    const { data } = await apiService().put<PostClassResponse>(
      `classes/${id}`,
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return data;
  },
  async postClassSeen(classId: string) {
    const { data } = await apiService().post<PostClassSeenResponse>(
      `classes/${classId}/seen`, {}, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return data;
  }
};
